import { Box, Flex, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useFormColors } from './FormThemeContext'

interface FormHeaderProps {
  title: string
  subtitle: string
  backPath: string
  icon?: React.ReactNode
}

export function FormHeader({ title, subtitle, backPath, icon }: FormHeaderProps) {
  const navigate = useNavigate()
  const c = useFormColors()

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex alignItems="center" gap={4}>
        <Box
          as="button" {...{ type: 'button' }}
          p={2}
          borderRadius="lg"
          color={c.textMuted}
          _hover={{ bg: c.bgHover, color: c.text }}
          transition="all 0.2s"
          cursor="pointer"
          onClick={() => navigate(backPath)}
        >
          {icon ?? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m12 19-7-7 7-7" />
              <path d="M19 12H5" />
            </svg>
          )}
        </Box>
        <Box>
          <Text fontSize="2xl" fontWeight="bold" color={c.text}>
            {title}
          </Text>
          <Text fontSize="sm" color={c.textMuted}>
            {subtitle}
          </Text>
        </Box>
      </Flex>
    </Flex>
  )
}
